import type { ExerciseCategory, ExerciseParam, MuscleGroup } from "../api/types";
import { t } from "../i18n";

export const CATEGORY_LABEL: Record<ExerciseCategory, string> = {
  strength: t("Força"),
  core: t("Core / abdômen"),
  mobility: t("Mobilidade"),
  stability: t("Estabilidade"),
  plyometric: t("Pliometria"),
  warmup: t("Aquecimento"),
  other: t("Outro"),
};

export const PARAM_LABEL: Record<ExerciseParam, string> = {
  reps_load: t("Repetições e carga"),
  reps: t("Só repetições"),
  time: t("Tempo"),
  distance: t("Distância"),
};

export const MUSCLE_LABEL: Record<MuscleGroup, string> = {
  chest: t("Peitoral"),
  back: t("Costas"),
  shoulders: t("Ombros"),
  biceps: t("Bíceps"),
  triceps: t("Tríceps"),
  forearms: t("Antebraços"),
  core: t("Core"),
  glutes: t("Glúteos"),
  quadriceps: t("Quadríceps"),
  hamstrings: t("Posteriores de coxa"),
  calves: t("Panturrilhas"),
  hip_flexors: t("Flexores do quadril"),
  adductors: t("Adutores"),
  abductors: t("Abdutores"),
  full_body: t("Corpo inteiro"),
};

export const CATEGORIES = Object.keys(CATEGORY_LABEL) as ExerciseCategory[];
export const PARAMS = Object.keys(PARAM_LABEL) as ExerciseParam[];
export const MUSCLES = Object.keys(MUSCLE_LABEL) as MuscleGroup[];

/** Máximo de grupos musculares por exercício (o servidor valida o mesmo limite). */
export const MAX_MUSCLES = 6;
